import React, { useRef, useEffect } from 'react';

import { DAILY, MONTHLY, WEEKLY } from '../Components/constants';
import { frequencyTypes, enumSlots } from '../../../../constants';
import {
  formatDate,
  prependZero,
  validateName,
} from '../../../../../../helpers';

export const invalidnameMsg = 'Invalid Program Name';

export const current = new Date();
export const todaysDate = formatDate(Date.now());
export const minStartTime = `${prependZero(
  current.getHours() + 1,
)}:${prependZero(current.getMinutes())}`;
export const BottomScroll = () => {
  const successRef = useRef(null);
  useEffect(() => successRef.current.scrollIntoView({ behavior: 'smooth' }));
  return <div ref={successRef} />;
};

// In future we need to make the meal plan possible for any start date
export const minStartDate = formatDate(
  new Date(current.getFullYear(), current.getMonth(), current.getDate()),
);
export const maxStartDate = formatDate(
  new Date(current.getFullYear(), current.getMonth() + 2, current.getDate()),
);
export const minEndDate = formatDate(
  new Date(current.getFullYear(), current.getMonth(), current.getDate() + 1),
);
// used in gift card for valid tilll
export const getDateAfterOneYear = (date, time) => {
  // date e.g. 2021-10-11
  // time e.g. 12:02

  const dateAsString = `${date} ${time}:00`;
  const jsDate = new Date(dateAsString);

  // js date after one year
  jsDate.setFullYear(jsDate.getFullYear() + 1);

  return {
    date: jsDate.toDateString(),
    time: formatDateAMPM(jsDate),
  };
};

// return date in 12hrs format
const formatDateAMPM = date => {
  let hours = date.getHours();
  let minutes = date.getMinutes();

  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours %= 12;

  if (!hours) hours = 12;
  minutes = minutes < 10 ? `0${minutes}` : minutes;

  return `${hours}:${minutes} ${ampm}`;
};

// used in Voucher and GiftCard
export const handleProgramNameChange = updateFormData => newName => {
  if (newName.length <= 21) {
    updateFormData({
      name: newName,
      nameErrMsg: '',
      nameHtextVis: true,
      showError: false,
      canNotGoNext: true,
    });
  } else {
    updateFormData({
      nameErrMsg: 'Max 20 characters allowed',
      nameHtextVis: true,
      canGoNext: false,
    });
  }

  if (!validateName(newName) && newName.length > 0) {
    updateFormData({
      nameErrMsg: invalidnameMsg,
      nameHtextVis: true,
    });
  }
};

// used in Voucher
// export const handleProgramTypeChange = updateFormData => value => {
//   updateFormData({
//     type: parseInt(value, 10),
//     showError: false,
//   });
// };

// used in Voucher and giftcard
export const handleAmountChange = updateFormData => newAmount => {
  updateFormData({ showError: false });

  const val = parseInt(newAmount, Number);

  if (val >= 0) {
    updateFormData({ amount: val });
    return;
  }

  if (!Number.isInteger(val)) {
    updateFormData({ amount: '' });
  }
};

export const handleMonthlyAmountChange = updateFormData => newAmount => {
  const val = Number.isInteger(parseInt(newAmount, Number)) ? newAmount : '';
  if (val >= 0) {
    updateFormData({
      showError: false,
      monthlyAmount: val,
      budget: val,
    });
  }
};
export const handleWeeklyAmountChange = updateFormData => newAmount => {
  const val = Number.isInteger(parseInt(newAmount, Number)) ? newAmount : '';
  if (val >= 0) {
    updateFormData({
      showError: false,
      weeklyAmount: val,
      budget: val,
    });
  }
};

export const handleDailyAmountChange = updateFormData => newAmount => {
  const val = Number.isInteger(parseInt(newAmount, Number)) ? newAmount : '';
  if (val >= 0) {
    updateFormData({
      showError: false,
      dailyAmount: val,
      budget: val,
    });
  }
};

export const validateCycleTypeAmount = formData => {
  switch (formData.cycleType) {
    case WEEKLY:
      return formData.weeklyAmount !== '' && formData.weeklyAmount > 0;
    case MONTHLY:
      return formData.monthlyAmount !== '' && formData.monthlyAmount > 0;
    case DAILY:
      return formData.dailyAmount !== '' && formData.dailyAmount > 0;
    default:
      return false;
  }
};

// used in giftcard
// export const handleAmountPerGiftCard = updateFormData => newAmount => {
//   updateFormData({ showError: false });

//   const val = parseInt(newAmount, Number);

//   if (!Number.isInteger(val)) {
//     updateFormData({
//       amount: 0,
//       displayAmount: '',
//     });
//     return;
//   }

//   if (val > MAX_AMOUNT_PER_GIFT_CARD * 10) {
//     updateFormData({
//       canGoNext: false,
//     });
//     return;
//   }

//   if (val <= MAX_AMOUNT_PER_GIFT_CARD * 100 && val > MAX_AMOUNT_PER_GIFT_CARD) {
//     updateFormData({
//       amount: val,
//       displayAmount: `${val}`,
//       amountErrMsg: giftCardAmountHelperText,
//       canGoNext: false,
//     });

//     return;
//   }

//   updateFormData({
//     amount: val,
//     displayAmount: `${val}`,
//     amountErrMsg: '',
//     canGoNext: true,
//   });
// };

// used in Voucher and gift card
export const handleStartDateChange = updateFormData => newDate => {
  updateFormData({
    showError: false,
    startDate: newDate,
  });

  // if (newDate === formatDate(Date.now())) {
  //   updateFormData({ startTime: minStartTime });
  //   return;
  // }

  // updateFormData({ startTime: '00:00' });
};

// used in voucher
// export const handleExpiryNumberChange = updateFormData => newNumber => {
//   updateFormData({ showError: false });
//   const val = parseInt(newNumber, Number);

//   if (val >= 0) {
//     updateFormData({ expiryNumber: parseInt(newNumber, Number) });
//     return;
//   }

//   if (!Number.isInteger(val)) updateFormData({ expiryNumber: '' });
// };

// used in voucher
// export const handleExpiryUnitChange = updateFormData => newUnit => {
//   updateFormData({
//     expiryUnit: newUnit,
//     showError: false,
//   });
// };

// used in voucher and giftcard
// export const handleStartTimeChange = updateFormData => newTime => {
//   updateFormData({
//     startTime: newTime,
//     showError: false,
//   });
// };

export const handleSlotChange = updateFormData => newSlot => {
  updateFormData({
    slots: newSlot,
    showError: false,
  });
};
// used in voucher
export const handleFrequencyChange = updateFormData => newFrequency => {
  updateFormData({
    showError: false,
    frequency: newFrequency,
    selectedDays: [],
    weekDay: 'Select day of the week',
    selectedDate: '',
  });
};

// used in voucher
export const handleOpenDaysClose = updateFormData => () => {
  updateFormData({
    openDays: false,
  });
};

export const handleSlotNameChange = (updateFormData, index, slots) => value => {
  const updatedSlots = [...slots];
  updatedSlots[index].name = value.name;
  updateFormData({
    slots: updatedSlots,
    showError: false,
  });
};

export const handleStartTimeChange = (
  updateFormData,
  index,
  slots,
) => value => {
  const updatedSlots = [...slots];
  updatedSlots[index].startTime = value;
  updateFormData({
    slots: updatedSlots,
    showError: false,
  });
};

export const handleEndTimeChange = (updateFormData, index, slots) => value => {
  const updatedSlots = [...slots];
  updatedSlots[index].endTime = value;
  updateFormData({
    slots: updatedSlots,
    showError: false,
  });
};

export const handleSlotAmountChange = (
  updateFormData,
  index,
  slots,
) => value => {
  const updatedSlots = [...slots];
  updatedSlots[index].amount = value;
  if (!Number.isInteger(parseInt(value, Number))) {
    updatedSlots[index].amount = '';
  }
  updateFormData({
    slots: updatedSlots,
    showError: false,
  });
};

// used in voucher
// export const handleOpenMonthClose = updateFormData => () => {
//   updateFormData({
//     openMonth: false,
//   });
// };

// used in voucher
// export const handleDayChange = updateFormData => newDay => {
//   updateFormData({
//     weekDay: newDay,
//     showError: false,
//   });
// };

// used in voucher
export const handleNeverEndCheck = (updateFormData, formData, minEnd) => () => {
  const updateNeverEnd = !formData.neverEnd;
  const updateEndDate = formData.neverEnd ? minEnd : '';
  updateFormData({
    showError: false,
    neverEnd: updateNeverEnd,
    endDate: updateEndDate,
  });
};
export const handleTopupTypeCheck = (updateFormData, val) => {
  let updateTopupType = 2;
  if (val) {
    updateTopupType = 1;
  }
  updateFormData({
    showError: false,
    topupType: updateTopupType,
  });
};

export const handleRestrictionTypeCheck = (updateFormData, val, formData) => {
  let updateRestrictionType = 2;
  if (val) {
    updateRestrictionType = 1;
    if (formData.slots.length === 0) formData.slots.push(enumSlots.FullDay);
  }
  updateFormData({
    showError: false,
    restrictionsType: updateRestrictionType,
  });
};

// used in voucher
export const handleEndDateChange = updateFormData => date => {
  updateFormData({
    endDate: date,
    showError: false,
  });
};

// export const handleGiftCardCountChange = updateFormData => newCount => {
//   updateFormData({ showError: false });
//   const val = parseInt(newCount, Number);

//   if (!Number.isInteger(val)) {
//     updateFormData({
//       giftCardCount: '',
//       grpIpColor: grey.z900,
//       cardIpColor: grey.z900,
//       reviewBtnDisabled: true,
//     });
//   } else if (MAX_GIFT_CARD_COUNT >= val > 0) {
//     updateFormData({
//       reviewBtnDisabled: false,
//       giftCardCount: parseInt(val, Number),
//       grpIpColor: grey.z500,
//       cardIpColor: grey.z900,
//     });
//   }
// };

export const finalDate = (selectedDays, selectedDate, day, type) => {
  if (type === '') return [];
  if (selectedDays.length) return selectedDays;
  if (selectedDate) return [selectedDate];
  return [day];
};

export const getVoucherProgramBody = programBody => {
  const {
    programId = '',
    name = '',
    selectedGroups = [],
    selectedLocations = [],
    selectedDays = [],
    monthlyAmount = '',
    startDate = '',
    endDate = '',
    neverEnd = false,
    slotsArray = [],
    workspaceID = '',
    topupType = 2,
    isLimits = false,
    cycleType = '',
    weeklyAmount = '',
    restrictionsType = '',
    flowType = 0,
    dailyAmount = '',
    selectedQuestions = [],
  } = programBody;

  let finalSlots = [];
  if (isLimits && restrictionsType === 1) {
    finalSlots = slotsArray?.map(slot => {
      return {
        type: slot?.type,
        start_time: slot?.startTime,
        end_time: slot?.endTime,
        amount: slot?.amount ? parseFloat(slot.amount) : 0,
      };
    });
  }

  const program = {
    name,
    program_id: programId,
    group_ids: selectedGroups,
    start_date: startDate,
    end_date: endDate,
    never_ends: neverEnd,
    workspace_id: workspaceID,
    monthly_amount: cycleType === MONTHLY ? monthlyAmount : 0,
    weekly_amount: cycleType === WEEKLY ? weeklyAmount : 0,
    daily_amount: cycleType === DAILY ? dailyAmount : 0,
    restrictions: {
      days: isLimits ? selectedDays : [1, 2, 3, 4, 5, 6, 7],
      pois: isLimits ? selectedLocations : [],
      slots: finalSlots,
    },
    topup_type: topupType,
    cycle_type: frequencyTypes[cycleType],
    restriction_type: restrictionsType,
    flow_type: flowType,
    question_ids: selectedQuestions,
  };
  return program;
};

export const getGiftCardProgramBody = programBody => {
  const {
    name = '',
    selectedGroups = [],
    amount = '',
    giftCardCount = 0,
  } = programBody;

  const program = {
    name,
    group_ids: selectedGroups,
    amount,
    entity_type: 'GIFT_CARD',
    entity_count: Number(giftCardCount),
  };

  return program;
};
